module.exports = __webpack_public_path__ + "img/truck.ece5bed.svg";